import { useCallback, useEffect } from 'react';
import { useAppDispatch } from 'app/config/storeConfig/hooks';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { globalConfirmModalActions } from 'app/globalConfirmModal';
import { showNotification } from 'app/providers/NotificationsProvider';
import { LockActionData, useOnBoxUnauthorizedAccess, useOnLockOpenTooLong } from 'entities/Box';
import { useRole } from 'entities/User';

export const useBoxAlerts = (): void => {
  const { t } = useAppTranslation('common');
  const dispatch = useAppDispatch();
  const { isManagement } = useRole();

  const lockOpenTooLongData = useOnLockOpenTooLong();
  const boxUnauthorizedAccessData = useOnBoxUnauthorizedAccess();

  const closeNotificationModal = useCallback((): void => {
    dispatch(globalConfirmModalActions.setGlobalConfirmModalData(null));
  }, [dispatch]);

  const openLockOpenTooLongModal = useCallback(
    (data: LockActionData): void => {
      dispatch(
        globalConfirmModalActions.setGlobalConfirmModalData({
          title: t('Box {{boxNumber}} has been open for too long!', { boxNumber: data.boxNumber }),
          description: t(
            'Attention! Box {{boxNumber}} (Lock: {{lockAddress}}) in {{warehouse}} has remained open longer than expected. Please check it if necessary.',
            {
              boxNumber: data.boxNumber,
              lockAddress: data.lockAddress,
              warehouse: data.warehouse,
            },
          ),
          onOk: closeNotificationModal,
          playSound: true,
        }),
      );
    },
    [closeNotificationModal, dispatch, t],
  );

  const openBoxUnauthorizedAccessModal = useCallback(
    (data: LockActionData): void => {
      dispatch(
        globalConfirmModalActions.setGlobalConfirmModalData({
          title: t('Unauthorized access detected on Box {{boxNumber}}!', { boxNumber: data.boxNumber }),
          description: t(
            'Attention! Unauthorized access attempt detected on Box {{boxNumber}} (Lock: {{lockAddress}}) in {{warehouse}}. Please verify the situation immediately.',
            {
              boxNumber: data.boxNumber,
              lockAddress: data.lockAddress,
              warehouse: data.warehouse,
            },
          ),
          onOk: closeNotificationModal,
          playSound: true,
        }),
      );
    },
    [closeNotificationModal, dispatch, t],
  );

  useEffect(() => {
    if (!isManagement) return;

    // if (lockOpenTooLongData) {
    //   openLockOpenTooLongModal(lockOpenTooLongData);
    //
    //   showNotification(
    //     'warning',
    //     t('Box {{boxNumber}} has been open for too long!', { boxNumber: lockOpenTooLongData.boxNumber }),
    //     t(
    //       'Attention! Box {{boxNumber}} (Lock: {{lockAddress}}) in {{warehouse}} has remained open longer than expected. Please check it if necessary.',
    //       {
    //         boxNumber: lockOpenTooLongData.boxNumber,
    //         lockAddress: lockOpenTooLongData.lockAddress,
    //         warehouse: lockOpenTooLongData.warehouse,
    //       },
    //     ),
    //   );
    // }

    if (boxUnauthorizedAccessData) {
      openBoxUnauthorizedAccessModal(boxUnauthorizedAccessData);

      showNotification(
        'warning',
        t('Unauthorized access detected on Box {{boxNumber}}!', { boxNumber: boxUnauthorizedAccessData.boxNumber }),
        t(
          'Attention! Unauthorized access attempt detected on Box {{boxNumber}} (Lock: {{lockAddress}}) in {{warehouse}}. Please verify the situation immediately.',
          {
            boxNumber: boxUnauthorizedAccessData.boxNumber,
            lockAddress: boxUnauthorizedAccessData.lockAddress,
            warehouse: boxUnauthorizedAccessData.warehouse,
          },
        ),
      );
    }
  }, [boxUnauthorizedAccessData, isManagement, lockOpenTooLongData, openBoxUnauthorizedAccessModal, openLockOpenTooLongModal, t]);
};
